import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, useRef } from "react";
import Image from 'next/image';
import { useHoverIntent } from 'react-use-hoverintent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
export const Thumb = t0 => {
  const $ = _c(24);
  const {
    selected,
    onClick,
    onMouseEnter,
    slide,
    addClasses,
    productName,
    thumbNumber
  } = t0;
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const fallbackRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouchDevice(window.matchMedia("(pointer: coarse)").matches);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      timeout: 100,
      sensitivity: 6,
      interval: 50
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [isHovering, intentRef] = useHoverIntent(t3);
  let t4;
  let t5;
  if ($[3] !== isHovering || $[4] !== isTouchDevice || $[5] !== onMouseEnter) {
    t4 = () => {
      if (!isTouchDevice && isHovering && onMouseEnter) {
        onMouseEnter();
      }
    };
    t5 = [isTouchDevice, isHovering, onMouseEnter];
    $[3] = isHovering;
    $[4] = isTouchDevice;
    $[5] = onMouseEnter;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  const isVideo = slide.type === "video";
  const thumbnailSrc = isVideo ? slide.thumbnail : `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${slide.file_name}`;
  const width = isVideo ? 120 : slide.width;
  const height = isVideo ? 68 : slide.height;
  const t6 = isTouchDevice ? fallbackRef : intentRef;
  const t7 = `${addClasses ? addClasses : ""}`;
  const t8 = `h-16 w-auto border-b-1 pb-2 ${selected ? "border-primary" : "border-transparent"}`;
  const t9 = isVideo ? `${productName} video` : `${productName} – thumbnail image #${thumbNumber}`;
  let t10;
  if ($[8] !== height || $[9] !== t8 || $[10] !== t9 || $[11] !== thumbnailSrc || $[12] !== width) {
    t10 = <Image className={t8} src={thumbnailSrc} alt={t9} width={width} height={height} quality={75} sizes="(max-height:80px) 100vw" />;
    $[8] = height;
    $[9] = t8;
    $[10] = t9;
    $[11] = thumbnailSrc;
    $[12] = width;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isVideo) {
    t11 = isVideo && <div className="absolute inset-0 flex items-center justify-center pb-2"><div className="w-6 h-6 rounded-full bg-black/60 flex items-center justify-center"><FontAwesomeIcon icon={faPlay} className="text-white text-2xs ml-0.5" /></div></div>;
    $[14] = isVideo;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onClick || $[17] !== t10 || $[18] !== t11) {
    t12 = <button type="button" onClick={onClick} className="outline-none relative">{t10}{t11}</button>;
    $[16] = onClick;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t6 || $[22] !== t7) {
    t13 = <div ref={t6} className={t7}>{t12}</div>;
    $[20] = t12;
    $[21] = t6;
    $[22] = t7;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};